import { render } from "./Page.vue?vue&type=template&id=23496c0c"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
script.render = render

export default script